import { render, staticRenderFns } from "./RelayInformationComponent.vue?vue&type=template&id=42779b60"
import script from "./RelayInformationComponent.vue?vue&type=script&lang=ts"
export * from "./RelayInformationComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports